var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[(!_vm.isAuthenticated)?[_c('Public',[_c('router-view')],1)]:[_c('Secure',[_c('router-view')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }